<template>
  <container-small>
    <background-wrapper :src="routeNameKebab + '/fullscreen-image_hero'" ext="png">
      <div class="hero product-hero">
        <text-container size="lg">
          <img class="hero__icon mb-3" :src="require(`@/assets/${routeNameKebab}/${routeNameKebab}-icon.png`)"/>
          <h1 v-html="$t(`products.${$route.name}.hero.title`)"/>
          <p class="h-sub" v-html="$t(`products.${$route.name}.hero.subtitle`)"/>
          <b-btn variant="primary" v-scroll-to="{ el: '#request-a-demo', offset: -70 }">
            <span v-html="btnText || $t('routes.RequestDemo')"/>
          </b-btn>
        </text-container>
      </div>
    </background-wrapper>
  </container-small>
</template>

<script>
export default {
  name: 'LetsGet',
  props: {
    title: String,
    btnText: String
  },
  computed: {
    routeNameKebab: app => app.$toKebabCase(app.$route.name)
  }
}
</script>

<style lang="sass" scoped>
.hero
  padding-top: 100px
  padding-bottom: 500px
  @media screen and (min-width: 2000px)
    // calc((100vw - 2000px)/4 ~ 0-40px
    padding-top: calc((100vw - 2000px)/12 + 100px)
    padding-bottom: calc((100vw - 2000px)/3 + 500px)
  +media-breakpoint-down(sm)
    // calc((100vw - 600px)/4 ~ 0-40px
    padding-top: calc((100vw - 600px)/4 + 100px)
    padding-bottom: calc((100vw - 600px)/4 + 420px)
  +media-breakpoint-down(xs)
    // calc((100vw - 320px)/7) ~ 0-40px
    padding-top: calc((100vw - 320px)/7 + 20px)
    padding-bottom: calc((100vw - 320px)/7 + 340px)

  &__icon
    width: 100px
    +media-breakpoint-down(xxs)
      width: 80px

  h1
    +media-breakpoint-down(xs)
      font-size: 2.2rem
    +media-breakpoint-down(xxs)
      font-size: 2rem
      word-break: break-word

  .text-container
    +media-breakpoint-down(xs)
      grid-template-columns: auto 1fr
      grid-column-gap: 20px
      text-align: left!important
      justify-items: start!important
      align-items: center

      > *:not(img):not(h1)
        grid-column-start: span 2

</style>



// WEBPACK FOOTER //
// src/components/ui/products/Hero.vue